import { setAlert } from "../alert";
import { SET_PROPERTY_FIELDS } from "../../types";
import { NumberValidator } from "../../../helpers/Validation";

/**
 * @name    updateTax
 * @param   event
 * @returns {function(...[*]=)}
 */
export const updateTax = event => async(dispatch, getState) => {
    // DESC: TAX - UNDER PROTEST
    const { name, value, type, dataset } = event.target;
    const { properties: { propertyFields } } = getState();

    //  DESC: Create new Property Fields Object and update it with new value
    const newPropertyFields = {
        ...propertyFields,
        [name]: value
    };
    //  DESC: Destructure necessary values to use to update property fields
    const {
        tax_protested,
        tax_protested_date,
        tax_current_amount_due,
        tax_previous_amount_due,
        tax_past_due_amount
    } = newPropertyFields;

    //  DESC: Pre-defined an empty errors array. All custom errors and warning will be push into this array
    const errors = [];

    //  DESC: Pre-define checking values
    // const Yes = "Y";
    const No = "N";

    try {
    //  DESC: Checking for number field and check for negative value. If negative, throw error
    //  DESC: isNumberNegative is a quick method to check for negative value. true or false
        if (type === "number") {
            if (NumberValidator.isNumberNegative(value)) {
                throw new TypeError(
                    dataset.displayName + " can not be negative!",
                    "error"
                );
            }
        }

        //  DESC: FINANCIAL - NET TAX ASSESSED VALUE / NET APPROVED VALUE

        switch (name) {
            case "tax_protested": {
            /* Get Tax Protest day  */
                const taxProtestedDate = document.querySelector(
                    '[name="tax_protested_date"]'
                );

                //  DESC: Checking Under Protest for No
                //  DESC: Remove Protest Date if value is satisfied
                if (tax_protested === No && tax_protested_date) {
                /* Remove tax protest date if tax protest date is set and tax protest value is No*/
                    newPropertyFields.tax_protested_date = "";

                    /* Push a notification let user know date is removed */
                    errors.push(
                        "Property is Not under Tax Protest. Tax Protest Date is removed."
                    );
                }

                /* Disabled field is tax protested value is No */
                taxProtestedDate.disabled = tax_protested === No;
                break;
            }
            case "tax_current_amount_due":
            case "tax_previous_amount_due":
            case "tax_past_due_amount": {
            /* Total Taxes Due */
            // "Base Year Amount Due" - "Base Year Amount Paid" + "Past Due Taxes"

                const total_taxes_due =
                parseFloat(tax_current_amount_due || 0) -
                parseFloat(tax_previous_amount_due || 0) +
                parseFloat(tax_past_due_amount || 0);

                newPropertyFields.tax_total_due =
                total_taxes_due < 0 ? 0 : total_taxes_due.toFixed(2);

                break;
            }
            default:
                break;
        }

        //  DESC: proceed to update value normally
        await dispatch({
            type: SET_PROPERTY_FIELDS,
            payload: newPropertyFields
        });
    }
    catch (error) {
        dispatch(setAlert(error.message, "error"));
    }
    finally {
    //  DESC: Throw error if there is any
        if (errors.length > 0) {
            errors.map(msg => dispatch(setAlert(msg, "info")));
        }
    }
};